import useSettingValue from "hooks/useSettingValue"

const usePrivacyPolicyLink = () => useSettingValue("PolicyLink") ?? ""

export default usePrivacyPolicyLink
